module.exports = __webpack_public_path__ + "static/media/jogo_americano_A3.f1457cbe.png";